import { useAppSelector } from 'store/hooks'

import { orderFormSpace } from '../namespaces/orderFormSpace'

// подготовка данных для формы
// TODO описать тип
export const useProductFormData = (
  currentSendForm: orderFormSpace.FormType,
) => {
  const rawForm = useAppSelector(
    state => state.orderForm.forms[currentSendForm],
  )

  return () => {
    const formProducts = !rawForm.products
      ? []
      : rawForm.products.map(currentProduct => {
          const resultParams = !rawForm.params
            ? []
            : rawForm.params
                .filter(item => item.productId === currentProduct.id)
                .map(currentParam => {
                  switch (currentParam.type) {
                    case 'DROPDOWN':
                      if (!currentParam.selectId) return null
                      return {
                        id: currentParam.id,
                        parameterValue: {
                          value: currentParam.selectId,
                        },
                      }
                    case 'NUMBER':
                      if (!currentParam.value) return null
                      return {
                        id: currentParam.id,
                        parameterValue: {
                          value: Number(currentParam.value),
                        },
                      }
                    case 'CHECKBOX':
                      if (currentParam.value === null) return null
                      return {
                        id: currentParam.id,
                        parameterValue: {
                          value: currentParam.value,
                        },
                      }

                    case 'TEXT':
                      if (!currentParam.value) return null
                      return {
                        id: currentParam.id,
                        parameterValue: {
                          value: currentParam.value,
                        },
                      }
                    default:
                      return null
                  }
                })
                .concat(
                  rawForm.images.map((currentImage: orderFormSpace.Images) => {
                    if (currentImage.productId !== currentProduct.id)
                      return null
                    if (!currentImage.serverUid || !currentImage.paramId)
                      return null
                    return {
                      id: currentImage.paramId,
                      parameterValue: {
                        value: currentImage.serverUid,
                      },
                    }
                  }),
                )
                .filter(item => item !== null)
          return {
            id: currentProduct.id,
            parameters: resultParams,
          }
        })

    // Фильтруем заполненные тайм-слоты (date не пустой)
    const filledTimeSlots = rawForm.timeSlots.filter(
      timeSlotItem =>
        timeSlotItem.date &&
        typeof timeSlotItem.date === 'string' &&
        timeSlotItem.date.trim() !== '',
    )

    const formTimeSlots =
      filledTimeSlots.length > 0
        ? filledTimeSlots.map(timeSlotItem => ({
            id: timeSlotItem.id,
            date: timeSlotItem.date,
          }))
        : null

    const form = {
      type: orderFormSpace.OrderType[currentSendForm],
      products: formProducts,
      location: rawForm.address,
      dealerCode: rawForm.dealerCode ? rawForm.dealerCode : null,
      timeSlots: formTimeSlots,
      user: {
        email: rawForm.email ? rawForm.email : null,
        additionalPhone: rawForm.phone
          ? rawForm.phone.replace(/[^\d+]/g, '')
          : null,
      },
    }
    return form
  }
}
